const config = {
  apiUrl: "https://ummatproduction.com/upapi/",
  uploadUrl: "https://ummatproduction.com/",
};

// const config = {
//   apiUrl: "http://localhost/upapi/",
//   uploadUrl: "http://localhost/",
// };

export default config;
